export default "__VITE_ASSET__9c55eb42__"